import { MutableRefObject, useEffect, useRef } from "react";
import { Subject, Subscription } from "rxjs";
import { ISignalRHubMessage } from "../interfaces/signalr";
import { signalRHubSubject } from "../utils/signalr";

export const useEventSubscriber = <T>(subject: Subject<T>, handler: Function) => {
    const savedHandler: MutableRefObject<Subscription> = useRef<Subscription>(new Subscription());

    useEffect(() => {
        const subscription: Subscription = subject.subscribe((info: T) => {
            handler(info);
        });

        savedHandler.current.add(subscription);

        return () => {
            subscription.unsubscribe();
            savedHandler.current.remove(subscription);
        }
    }, [])
}

export const useRefreshEventSubscriber = (refreshComponent: string, handler: Function) => {
    const savedHandler: MutableRefObject<Subscription> = useRef<Subscription>(new Subscription());

    useEffect(() => {
        const subscription: Subscription = signalRHubSubject.subscribe((info: ISignalRHubMessage) => {
            if (info.name.toLowerCase() === refreshComponent.toLowerCase()) {
                handler();
            }
        });

        savedHandler.current.add(subscription);

        return () => {
            subscription.unsubscribe();
            savedHandler.current.remove(subscription);
        }
    }, [])
}